import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ButtonFlavor, ButtonSize, ButtonType } from '../models/button-config.model';

@Component({
  selector: 'pseic-async-button',
  templateUrl: './pseic-async-button.component.html',
  styleUrls: ['./pseic-async-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PseicAsyncButtonComponent implements OnInit {
  @Input() isLoading$?: BehaviorSubject<boolean>;
  @Input() isDisabled$?: BehaviorSubject<boolean>;
  @Input() isGhost?: boolean;
  @Input() size? = ButtonSize.SMALL;
  @Input() flavor? = ButtonFlavor.PRIMARY;
  @Input() type? = ButtonType.BUTTON;
  @Input() formName?: string;

  @Output() buttonClicked = new EventEmitter();
  ButtonFlavor = ButtonFlavor;

  ngOnInit(): void {
    if (!this.isDisabled$ && this.isLoading$) {
      this.isDisabled$ = this.isLoading$;
    }
  }

  buttonClickHandler($event: Event): void {
    $event.stopPropagation();
    if (!this.isDisabled$?.value && !this.isLoading$?.value) {
      this.buttonClicked.emit();
    }
  }
}
